import { IMorningUpdate } from "./mongo";

export interface ICoupon {
    open: number;
    close: number;
    high: number;
    low: number;
    highest: number;
    lowest: number;
    earliest: number;
    latest: number;
    couponName: string;
    previousClose: number;
}

export interface IDemoData {
    FIP: number;
    housingStarts: number;
    popAgeTeen: number;
    popAgeYAdult: number;
    popAgeAdult: number;
    popAgeMiddle: number;
    popAgeElder: number;
    totalPop: number;
    totalPopOwn: number;
    totalPopRent: number;
    hariNum: number;
}

export interface IRentalData {
    rentSqFt: number;
    buySqFt: number;
    buyYoY: number;
    rentYoY: number;
}
export interface ICombinedRentalData extends IRentalData {
    totalPop: number;
    totalPopOwn: number;
    totalPopRent: number;
    hariNum: number;
}

export interface IBaseArticleData {
    _id?: string;
    __v?: number;
    createdAt?: string;
    updatedAt?: string;
    title: string;
    body: string;
}

export interface IMauldinTFTFData extends IBaseArticleData {
    published: boolean;
}

export interface IMarketWrapData extends IBaseArticleData {
    summary: string;
    published: boolean;
}

export interface IBarrysInsights extends IBaseArticleData {
    videoUrl: string;
    summary: string;
    published: boolean;
}

export interface INewsletterData extends IBaseArticleData {
    subtitle: string;
    summary: string;
    published: boolean;
}

export interface IPEData extends IBaseArticleData {
    imgUrl: string;
    presentationUrl: string;
    featured: boolean;
    order?: number;
    videoUrl: string;
    published: boolean;
    legacyIframe?: boolean;
}

export interface ISocialShareData extends IBaseArticleData {
    imgUrl: string;
    subject?: string;
    caption: string;
    categories: string[];
    published: boolean;
}
export interface ICorpSearch {
    corpID: string;
    corpName: string;
}
export interface ISocialStudioScriptData extends IBaseArticleData {
    featured: boolean;
    tags: string[];
    caption: string;
    hideCorp: ICorpSearch[];
    published: boolean;
    type?: "mbs" | "user";
    userID: string | null;
    subject?: string;
}
type TTemplateIndex = "1" | "2" | "3" | "4" | "5" | "6";

export interface IFrame {
    _id: string;
    imageUrl: string;
    backgroundColor: string;
    textColor: string;
    accentPrimary: string;
    accentSecondary: string;
    userID?: string;
    createdAt?: Date;
    updatedAt?: Date;
    templateIndex?: TTemplateIndex;
    frameID?: string;
    corpID?: string;
}

export type TData =
    | IMorningUpdate
    | IMauldinTFTFData
    | IMarketWrapData
    | IBarrysInsights
    | INewsletterData
    | IPEData
    | ISocialShareData;

export interface IHomeReportLead {
    id: string;
    ownerId: string;
    applicant: {
        name: string;
        email: string;
    };
    meta: {
        robin?: {
            home_report?: {
                highway?: {
                    status: string;
                };
            };
        };
        transactionId?: string;
    };
    createdAt: string;
    updatedAt: string;
}

export enum FEATURE_FLAGS {
    ipa = "mbs-ipa-available",
    navSearchBoth = "nice-to-meet-you-asdf",
    navSearch = "mbs-navigation-search",
    refi = "mbs-lo-refr-available",
    cm = "mbs-lo-clientmgrr-available",
    mkit = "mbs-lo-marketingkitsr-available",
    aiBot = "mbs-ai-bot",
    sfs = "mbs-sfs-available",
    strv2 = "mbs-strike-rate-v2-available",
    reinvest = "mbs-lo-reinvest_revamp-available",
    srHRSync = "mbs-lo-sr-hr-sync-available",
    braze = "mbs-braze-available",
    morningUpdateText = "mbs-morning-update-text-available",
    affordability = "mbs-affordability-available",
    brazeV2 = "mbs-braze-v2-available",
    mbestimate = "mbs-mbestimate-available",
    dcPurchase = "mbs-dc-purchase-available",
}
